import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";import "@/index.css";
import { LanguageProvider, useLang } from "@/components/settld/i18n";
import { ThemeProvider } from "@/components/settld/theme";
import { Preloader } from "@/components/settld/Preloader";
import { Header } from "@/components/settld/Header";
import { Hero } from "@/components/settld/Hero";
import { Marquee } from "@/components/settld/Marquee";
import { Problem } from "@/components/settld/Problem";
import { HowItWorks } from "@/components/settld/HowItWorks";
import { Platform } from "@/components/settld/Platform";
import { Comparison } from "@/components/settld/Comparison";
import { Pricing } from "@/components/settld/Pricing";
import { Testimonials } from "@/components/settld/Testimonials";
import { Trust } from "@/components/settld/Trust";
import { BrandBand } from "@/components/settld/BrandBand";
import { QuoteCTA } from "@/components/settld/QuoteCTA";
import { Footer } from "@/components/settld/Footer";
import { ConciergeWidget } from "@/components/settld/ConciergeWidget";
import Admin from "@/pages/Admin";

function SiteContent({ start }) {
  const { sections } = useLang();
  return (
    <>
      <Header start={start} />
      <main>
        <Hero start={start} />
        {sections.marquee && <Marquee />}
        {sections.problem && <Problem />}
        {sections.howItWorks && <HowItWorks />}
        {sections.platform && <Platform />}
        {sections.comparison && <Comparison />}
        {sections.pricing && <Pricing />}
        {sections.testimonials && <Testimonials />}
        {sections.trust && <Trust />}
        {sections.brandBand && <BrandBand />}
        {sections.quote && <QuoteCTA />}
      </main>
      <Footer />
      <ConciergeWidget />
    </>
  );
}

function SiteShell() {
  const { options } = useLang();
  const skipIntro = options.skipIntroReturning && localStorage.getItem("settld-visited") === "1";
  const [loading, setLoading] = useState(!skipIntro);
  const [introDone, setIntroDone] = useState(skipIntro);

  useEffect(() => {
    localStorage.setItem("settld-visited", "1");
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const timer = skipIntro ? null : setTimeout(() => setLoading(false), 1100);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      if (timer) clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AnimatePresence onExitComplete={() => setIntroDone(true)}>
        {loading && <Preloader />}
      </AnimatePresence>
      <Toaster position="top-center" richColors />
      <SiteContent start={introDone} />
    </>
  );
}

function Site() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <div className="bg-paper font-sans text-ink antialiased">
          <SiteShell />
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}
